export enum DeviceType {
    Mobile = 'Mobile',
    Desktop = 'Desktop'
}
